'use client'

import { cloudflareImages } from './markdoc/Images'
import { LogoContainer } from './Logo'
import SocialLink from './SocialLink'
import Link from 'next/link'
import Image from 'next/image'

export function Footer() {
  const currentYear = new Date().getFullYear()

  const footerLinks = [
    {
      title: 'Features',
      links: [
        { name: 'Visibility', link: '/features/cost-visibility' },
        {
          name: 'Insights',
          link: '/features/insights',
        },
        {
          name: 'Savings',
          link: '/features/automated-savings',
        },
        {
          name: 'Usage Groups',
          link: '/features/usage-groups',
        },
        {
          name: 'Notifications',
          link: '/features/monitors',
        },
        {
          name: 'Integrations',
          link: '/features/integrations',
        },
      ],
    },
    {
      title: 'About',
      links: [
        { name: 'About Us', link: '/about' },
        {
          name: 'Pricing',
          link: '/pricing',
        },
        {
          name: 'FAQ',
          link: '/about#faq',
        },
        {
          name: 'Contact Support',
          link: 'mailto:support@select.dev?subject=SELECT%20Support%20Request&body=Hello%2C%0D%0A%0D%0A%3Cplease%20describe%20your%20issue%2C%20including%20any%20relevant%20details%20and%20screenshots%20to%20help%20our%20team%20diagnose%20your%20issue%3E%0D%0A%0D%0ACompany%20Name%3A%20%3Cyour%20company%20name%3E%0D%0Ac',
        },
        {
          name: 'Status',
          link: 'https://status.select.dev',
        },
        {
          name: 'Careers',
          link: '/careers',
        },
      ],
    },
    {
      title: 'Resources',
      links: [
        { name: 'Docs', link: '/docs' },
        {
          name: 'Changelog',
          link: '/changelog',
        },
        {
          name: 'Blog',
          link: '/posts',
        },
        {
          name: 'dbt-snowflake-monitoring',
          link: '/docs/dbt-snowflake-monitoring',
        },
        {
          name: 'Automated Savings Estimate',
          link: '/docs/health-check-app',
        },
      ],
    },
    {
      title: 'Legal',
      links: [
        { name: 'Terms', link: '/terms' },
        {
          name: 'Security',
          link: '/security',
        },
        {
          name: 'Privacy',
          link: '/privacy',
        },
        {
          name: 'Cookies',
          link: '/cookies',
        },
        {
          name: 'Data Processing Agreement',
          link: '/data-processing-agreement',
        },
        {
          name: 'CCPA',
          link: '/ccpa',
        },
      ],
    },
  ]
  return (
    <footer className="flex w-full items-center justify-center border-t border-[#1C1D29] bg-[#0B0C14] px-5 pb-8 pt-[60px] text-white sm:px-10 xl:px-[100px] xl:pb-10 xl:pt-20">
      <div className="flex w-full max-w-[1240px] flex-col items-center justify-between gap-20 xl:gap-[100px]">
        <div className="flex w-full flex-col items-start justify-between gap-8 xl:flex-row xl:gap-[113px]">
          <div className="flex h-[255px] flex-col gap-2.5">
            <div className="flex flex-col gap-2.5">
              <LogoContainer className="h-7" />
              <p className="w-[240px] text-base leading-[140%] text-white/80">
                The Snowflake optimization and cost management platform
              </p>
            </div>

            <div className="flex items-center gap-2.5 pt-3">
              <SocialLink name="x" link="https://twitter.com/select_dev" />
              <SocialLink name="github" link="https://github.com/get-select" />
              <SocialLink
                name="linkedin"
                link="https://linkedin.com/company/get-select"
              />
            </div>

            <div className="flex gap-4 pt-10">
              <Image
                src={
                  cloudflareImages.snowflakeSelectPartnerBadge.cloudflareImageId
                }
                width={cloudflareImages.snowflakeSelectPartnerBadge.width}
                height={cloudflareImages.snowflakeSelectPartnerBadge.height}
                alt="Snowflake Select Partner Badge"
                sizes="100vw"
                className="w-[70px]"
              />
              <Image
                src={cloudflareImages.soc2Badge.cloudflareImageId}
                width={cloudflareImages.soc2Badge.width}
                height={cloudflareImages.soc2Badge.height}
                alt="Snowflake SOC2 Certification"
                sizes="100vw"
                className="w-[70px]"
              />
            </div>
          </div>

          <div className="flex w-full flex-col flex-wrap items-start justify-between gap-8 sm:flex-row sm:gap-16 xl:gap-0">
            {footerLinks.map((footerLink) => (
              <div key={footerLink.title} className="flex flex-col gap-2.5">
                <h4 className="pb-2.5 text-xs uppercase leading-[120%] tracking-[0.48px] text-white/50">
                  {footerLink.title}
                </h4>

                <ul className="flex flex-col gap-2.5 xl:gap-3">
                  {footerLink.links.map((link) => (
                    <li
                      key={link.name}
                      className="h-[20px] text-[13.234px] leading-[21px]"
                    >
                      <Link
                        href={link.link}
                        className=" text-white transition-colors duration-300 hover:text-[#38BDF9]"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="relative flex w-full items-center justify-center pt-6 xl:pt-[30px]">
          <div className="absolute top-0 h-[1px] w-full bg-gradient-to-r from-white/[0.01] via-white/[0.07] to-white/[0.01]" />
          <p className="text-xs leading-[120%] text-white/60">
            © {currentYear} Select Labs Inc.
          </p>
        </div>
      </div>
    </footer>
  )
}
